module.exports = __webpack_public_path__ + "static/img/Garang-Kuol.48c6464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Garang-Kuol.jpg
// module id = QpEq
// module chunks = 0